export default __webpack_public_path__ + "static/AeonikBlack-1367e0fa03eaabd53966eff61f1ce310.woff";